// src/services/productService.ts - VERSION ÉTENDUE avec méthodes admin
import api from './api';

// ✅ MODIFIÉ - Interface ProductCreate avec delivery_fee
export interface ProductCreate {
  name: string;
  description: string;
  price: number;
  category_id: number;
  stock: number;
  delivery_fee?: number;  // ✅ NOUVEAU CHAMP
}

// ✅ MODIFIÉ - Interface ProductUpdate avec delivery_fee
export interface ProductUpdate {
  name?: string;
  description?: string;
  price?: number;
  category_id?: number;
  stock?: number;
  delivery_fee?: number;  // ✅ NOUVEAU CHAMP
}

// ✅ MODIFIÉ - Interface Product avec delivery_fee et info owner
export interface Product {
  id: number;
  name: string;
  description: string;
  price: number;
  stock: number;
  delivery_fee: number;   // ✅ NOUVEAU CHAMP (obligatoire dans response)
  category_id: number;
  owner_id: number;
  image_url: string;
  thumbnail_url: string;
  created_at: string;
  updated_at: string;
  sold?: number;
  // ✅ NOUVEAU - Vraies statistiques de vente (calculées en temps réel)
  real_sold?: number;
  real_revenue?: number;
  // ✅ NOUVEAU - Infos owner (pour admin)
  owner_name?: string;
  owner_email?: string;
  owner_phone?: string;
}

// ✅ NOUVELLE INTERFACE - Statistiques en temps réel d'un produit
export interface ProductSalesStats {
  product_id: number;
  total_sold: number;
  total_revenue: number;
  confirmed_orders: number;
  pending_orders: number;
  cancelled_orders: number;
  last_sale_date?: string;
}

// ✅ NOUVELLE INTERFACE - Filtres admin
export interface AdminProductFilters {
  search?: string;
  category_id?: number;
  owner_id?: number;
  min_price?: number;
  max_price?: number;
  has_stock?: boolean;
  created_after?: string;
  created_before?: string;
  skip?: number;
  limit?: number;
}

class ProductService {
  // ===== MÉTHODES CRUD EXISTANTES =====
  
  async getProducts(): Promise<Product[]> {
    try {
      console.log('📦 Récupération de tous les produits...');
      
      const response = await api.get('/products/');
      
      console.log('✅ Produits récupérés:', response.data.length);
      return response.data;
      
    } catch (error) {
      console.error('❌ Erreur lors de la récupération des produits:', error);
      throw error;
    }
  }

  async getProduct(productId: number): Promise<Product> {
    try {
      console.log('🔍 Récupération produit ID:', productId);
      
      const response = await api.get(`/products/${productId}`);
      
      console.log('✅ Produit récupéré:', response.data.name);
      return response.data;
      
    } catch (error) {
      console.error('❌ Erreur lors de la récupération du produit:', error);
      throw error;
    }
  }

  async createProduct(productData: ProductCreate, image: File): Promise<Product> {
    try {
      console.log('🚀 Création produit:', productData.name);
      
      // ✅ MODIFIÉ - Inclure delivery_fee dans FormData
      const formData = new FormData();
      formData.append('name', productData.name);
      formData.append('description', productData.description);
      formData.append('price', productData.price.toString());
      formData.append('category_id', productData.category_id.toString());
      formData.append('stock', productData.stock.toString());
      formData.append('delivery_fee', (productData.delivery_fee || 0).toString()); // ✅ NOUVEAU
      formData.append('image', image);
      
      const response = await api.post('/products/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      console.log('✅ Produit créé avec succès:', response.data.id);
      return response.data;
      
    } catch (error) {
      console.error('❌ Erreur lors de la création du produit:', error);
      throw error;
    }
  }

  async updateProduct(productId: number, productData: ProductUpdate, image?: File): Promise<Product> {
    try {
      console.log('🔧 Mise à jour produit ID:', productId);
      
      const formData = new FormData();
      
      // ✅ MODIFIÉ - Inclure delivery_fee si fourni
      if (productData.name !== undefined) formData.append('name', productData.name);
      if (productData.description !== undefined) formData.append('description', productData.description);
      if (productData.price !== undefined) formData.append('price', productData.price.toString());
      if (productData.category_id !== undefined) formData.append('category_id', productData.category_id.toString());
      if (productData.stock !== undefined) formData.append('stock', productData.stock.toString());
      if (productData.delivery_fee !== undefined) formData.append('delivery_fee', productData.delivery_fee.toString()); // ✅ NOUVEAU
      
      if (image) {
        formData.append('image', image);
      }
      
      const response = await api.put(`/products/${productId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      console.log('✅ Produit mis à jour avec succès');
      return response.data;
      
    } catch (error) {
      console.error('❌ Erreur lors de la mise à jour du produit:', error);
      throw error;
    }
  }

  async deleteProduct(productId: number): Promise<void> {
    try {
      console.log('🗑️ Suppression produit ID:', productId);
      
      await api.delete(`/products/${productId}`);
      
      console.log('✅ Produit supprimé avec succès');
      
    } catch (error) {
      console.error('❌ Erreur lors de la suppression du produit:', error);
      throw error;
    }
  }

  // ===== NOUVELLES MÉTHODES ADMIN =====
  
  // ✅ NOUVEAU - Récupérer tous les produits (vue admin)
  async getAdminProducts(filters?: AdminProductFilters): Promise<Product[]> {
    try {
      console.log('👑 Récupération produits (vue admin)...');
      
      let endpoint = '/admin/products?';
      
      if (filters) {
        if (filters.search) endpoint += `search=${encodeURIComponent(filters.search)}&`;
        if (filters.category_id) endpoint += `category_id=${filters.category_id}&`;
        if (filters.skip) endpoint += `skip=${filters.skip}&`;
        if (filters.limit) endpoint += `limit=${filters.limit}&`;
      }
      
      const response = await api.get(endpoint);
      
      console.log('✅ Produits admin récupérés:', response.data.length);
      return response.data;
      
    } catch (error) {
      console.error('❌ Erreur lors de la récupération admin des produits:', error);
      throw error;
    }
  }

  // ✅ NOUVEAU - Supprimer un produit (admin)
  async deleteProductAsAdmin(productId: number, reason?: string): Promise<void> {
    try {
      console.log('👑🗑️ Suppression admin produit ID:', productId);
      
      let endpoint = `/admin/products/${productId}`;
      if (reason) {
        endpoint += `?reason=${encodeURIComponent(reason)}`;
      }
      
      await api.delete(endpoint);
      
      console.log('✅ Produit supprimé par admin avec succès');
      
    } catch (error) {
      console.error('❌ Erreur lors de la suppression admin du produit:', error);
      throw error;
    }
  }

  // ✅ NOUVEAU - Récupérer les statistiques admin des produits
  async getAdminProductsStats(): Promise<{
    total_products: number;
    total_categories: number;
    total_farmers_with_products: number;
    products_without_stock: number;
    products_with_high_price: number;
    recent_products: number;
    average_price: number;
    average_stock: number;
  }> {
    try {
      console.log('📊 Récupération stats admin produits...');
      
      // Récupérer tous les produits et calculer les stats côté client
      // (en attendant un endpoint dédié côté backend)
      const products = await this.getAdminProducts();
      
      const uniqueFarmers = new Set(products.map(p => p.owner_id)).size;
      const productsWithoutStock = products.filter(p => p.stock === 0).length;
      const highPriceThreshold = 100000; // 100k FCFA
      const productsWithHighPrice = products.filter(p => p.price > highPriceThreshold).length;
      
      const oneWeekAgo = new Date();
      oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
      const recentProducts = products.filter(p => new Date(p.created_at) > oneWeekAgo).length;
      
      const totalPrice = products.reduce((sum, p) => sum + p.price, 0);
      const totalStock = products.reduce((sum, p) => sum + p.stock, 0);
      
      const stats = {
        total_products: products.length,
        total_categories: new Set(products.map(p => p.category_id)).size,
        total_farmers_with_products: uniqueFarmers,
        products_without_stock: productsWithoutStock,
        products_with_high_price: productsWithHighPrice,
        recent_products: recentProducts,
        average_price: products.length > 0 ? totalPrice / products.length : 0,
        average_stock: products.length > 0 ? totalStock / products.length : 0
      };
      
      console.log('✅ Stats admin calculées:', stats);
      return stats;
      
    } catch (error) {
      console.error('❌ Erreur lors du calcul des stats admin:', error);
      throw error;
    }
  }

  // ===== MÉTHODES POUR VRAIES STATISTIQUES (EXISTANTES) =====
  
  async getProductSalesStats(productId: number): Promise<ProductSalesStats | null> {
    try {
      console.log('📊 Récupération stats vente produit ID:', productId);
      
      const response = await api.get(`/farmer/products/${productId}/sales-stats`);
      
      console.log('✅ Stats récupérées:', response.data);
      return response.data;
      
    } catch (error) {
      console.warn('⚠️ Impossible de récupérer les stats de vente pour le produit', productId, ':', error);
      return null;
    }
  }

  async getFarmerProductsWithRealStats(farmerId?: number): Promise<Product[]> {
    try {
      console.log('📦 Récupération produits farmer avec vraies stats...');
      
      // Récupérer les produits de base
      const products = await this.getFarmerProducts(farmerId);
      
      // Enrichir avec les vraies statistiques de vente
      const enrichedProducts = await Promise.all(
        products.map(async (product) => {
          try {
            const salesStats = await this.getProductSalesStats(product.id);
            
            if (salesStats) {
              return {
                ...product,
                real_sold: salesStats.total_sold,
                real_revenue: salesStats.total_revenue
              };
            }
            
            return {
              ...product,
              real_sold: 0,
              real_revenue: 0
            };
          } catch (error) {
            console.warn(`Erreur stats pour produit ${product.id}:`, error);
            return {
              ...product,
              real_sold: 0,
              real_revenue: 0
            };
          }
        })
      );
      
      console.log('✅ Produits enrichis avec vraies stats:', enrichedProducts.length);
      return enrichedProducts;
      
    } catch (error) {
      console.error('❌ Erreur lors de la récupération avec stats:', error);
      // Fallback: retourner les produits sans enrichissement
      return this.getFarmerProducts(farmerId);
    }
  }

  async getAllProductsSalesStats(farmerId?: number): Promise<ProductSalesStats[]> {
    try {
      console.log('📊 Récupération de toutes les stats de vente...');
      
      const endpoint = farmerId 
        ? `/farmer/${farmerId}/products/sales-stats`
        : '/farmer/products/sales-stats';
      
      const response = await api.get(endpoint);
      
      console.log('✅ Stats globales récupérées:', response.data.length, 'produits');
      return response.data;
      
    } catch (error) {
      console.warn('⚠️ Impossible de récupérer les stats globales:', error);
      return [];
    }
  }

  getRealSoldQuantity(product: Product): number {
    // Prioriser real_sold si disponible, sinon utiliser sold (avec warning)
    if (product.real_sold !== undefined) {
      return product.real_sold;
    }
    
    console.warn(`⚠️ Utilisation de sold statique pour produit ${product.id}. Considérer l'enrichissement avec vraies stats.`);
    return product.sold || 0;
  }

  // ===== VALIDATIONS =====
  
  validateProductData(data: ProductCreate): string[] {
    const errors: string[] = [];
    
    if (!data.name || data.name.trim().length < 2) {
      errors.push('Le nom du produit doit faire au moins 2 caractères');
    }
    
    if (data.name && data.name.length > 100) {
      errors.push('Le nom du produit ne peut pas dépasser 100 caractères');
    }
    
    if (!data.description || data.description.trim().length < 10) {
      errors.push('La description doit faire au moins 10 caractères');
    }
    
    if (data.description && data.description.length > 1000) {
      errors.push('La description ne peut pas dépasser 1000 caractères');
    }
    
    if (!data.price || data.price <= 0) {
      errors.push('Le prix doit être supérieur à 0');
    }
    
    if (data.price && data.price > 10000000) {
      errors.push('Le prix ne peut pas dépasser 10 000 000 FCFA');
    }
    
    if (!data.category_id || data.category_id <= 0) {
      errors.push('Veuillez sélectionner une catégorie');
    }
    
    if (data.stock < 0) {
      errors.push('Le stock ne peut pas être négatif');
    }
    
    if (data.stock > 999999) {
      errors.push('Le stock ne peut pas dépasser 999 999 unités');
    }
    
    // ✅ NOUVEAU - Validation delivery_fee
    if (data.delivery_fee !== undefined && data.delivery_fee < 0) {
      errors.push('Les frais de livraison ne peuvent pas être négatifs');
    }
    
    if (data.delivery_fee && data.delivery_fee > 50000) {
      errors.push('Les frais de livraison ne peuvent pas dépasser 50 000 FCFA');
    }
    
    return errors;
  }

  validateImageFile(file: File): string[] {
    const errors: string[] = [];
    
    // Taille maximale: 5MB
    const maxSize = 5 * 1024 * 1024;
    if (file.size > maxSize) {
      errors.push('L\'image ne peut pas dépasser 5MB');
    }
    
    // Types acceptés
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      errors.push('Format d\'image non supporté. Utilisez: JPG, PNG, GIF ou WebP');
    }
    
    return errors;
  }

  // ===== UTILITAIRES =====
  
  getImageUrl(imagePath: string): string {
    if (!imagePath) return '/placeholder-product.jpg';
    
    // Si c'est déjà une URL complète, la retourner telle quelle
    if (imagePath.startsWith('http')) {
      return imagePath;
    }
    
    // Sinon, construire l'URL relative
    return imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
  }

  formatPrice(price: number): string {
    return `${price.toLocaleString()} FCFA`;
  }

  formatDeliveryFee(fee: number): string {
    return fee > 0 ? `${fee.toLocaleString()} FCFA` : 'Gratuite';
  }

  calculateTotalWithDelivery(price: number, deliveryFee: number, quantity: number = 1): number {
    return (price * quantity) + (deliveryFee || 0);
  }

  getDeliveryFeeStatus(fee: number): 'free' | 'paid' {
    return fee > 0 ? 'paid' : 'free';
  }

  getTotalProductCost(product: Product, quantity: number = 1): {
    subtotal: number;
    deliveryFee: number;
    total: number;
    formattedSubtotal: string;
    formattedDeliveryFee: string;
    formattedTotal: string;
  } {
    const subtotal = product.price * quantity;
    const deliveryFee = product.delivery_fee || 0;
    const total = subtotal + deliveryFee;
    
    return {
      subtotal,
      deliveryFee,
      total,
      formattedSubtotal: this.formatPrice(subtotal),
      formattedDeliveryFee: this.formatDeliveryFee(deliveryFee),
      formattedTotal: this.formatPrice(total)
    };
  }

  // ===== MÉTHODES SPÉCIFIQUES FARMER =====
  
  async getFarmerProducts(farmerId?: number): Promise<Product[]> {
    try {
      console.log('📦 Récupération produits du farmer...');
      
      // Si farmerId fourni, utiliser l'endpoint général avec filtre
      if (farmerId) {
        const response = await api.get(`/products/farmer/${farmerId}`);
        console.log('✅ Produits du farmer récupérés:', response.data.length);
        return response.data;
      }
      
      // Sinon, utiliser l'endpoint farmer connecté
      const response = await api.get('/farmer/products');
      
      console.log('✅ Produits du farmer connecté récupérés:', response.data.length);
      return response.data;
      
    } catch (error) {
      console.error('❌ Erreur lors de la récupération des produits farmer:', error);
      
      // Fallback: utiliser l'endpoint général et filtrer côté frontend si nécessaire
      try {
        console.log('🔄 Tentative avec endpoint général...');
        const allProducts = await this.getProducts();
        console.log('✅ Fallback réussi:', allProducts.length, 'produits récupérés');
        return allProducts;
      } catch (fallbackError) {
        console.error('❌ Erreur du fallback:', fallbackError);
        throw error; // Relancer l'erreur originale
      }
    }
  }

  // ===== FILTRES ET RECHERCHE =====
  
  async searchProducts(query: string): Promise<Product[]> {
    try {
      console.log('🔍 Recherche produits:', query);
      
      const response = await api.get(`/products/search?q=${encodeURIComponent(query)}`);
      
      console.log('✅ Résultats trouvés:', response.data.length);
      return response.data;
      
    } catch (error) {
      console.error('❌ Erreur lors de la recherche:', error);
      // Fallback: retourner liste vide au lieu d'erreur
      return [];
    }
  }

  async getProductsByCategory(categoryId: number): Promise<Product[]> {
    try {
      console.log('📂 Produits par catégorie:', categoryId);
      
      const response = await api.get(`/products/category/${categoryId}`);
      
      console.log('✅ Produits récupérés pour la catégorie:', response.data.length);
      return response.data;
      
    } catch (error) {
      console.error('❌ Erreur lors de la récupération par catégorie:', error);
      return [];
    }
  }

  // ===== FILTRES LOCAUX =====
  
  filterProductsByPrice(products: Product[], minPrice: number, maxPrice: number): Product[] {
    return products.filter(product => {
      const totalCost = this.calculateTotalWithDelivery(product.price, product.delivery_fee);
      return totalCost >= minPrice && totalCost <= maxPrice;
    });
  }

  sortProducts(products: Product[], sortBy: 'name' | 'price' | 'price_with_delivery' | 'created_at'): Product[] {
    return [...products].sort((a, b) => {
      switch (sortBy) {
        case 'name':
          return a.name.localeCompare(b.name);
        case 'price':
          return a.price - b.price;
        case 'price_with_delivery':
          const totalA = this.calculateTotalWithDelivery(a.price, a.delivery_fee);
          const totalB = this.calculateTotalWithDelivery(b.price, b.delivery_fee);
          return totalA - totalB;
        case 'created_at':
          return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
        default:
          return 0;
      }
    });
  }

  groupProductsByDeliveryType(products: Product[]): {
    freeDelivery: Product[];
    paidDelivery: Product[];
  } {
    const freeDelivery = products.filter(p => (p.delivery_fee || 0) === 0);
    const paidDelivery = products.filter(p => (p.delivery_fee || 0) > 0);
    
    return { freeDelivery, paidDelivery };
  }

  // ===== STATISTIQUES =====
  
  getProductStats(products: Product[]): {
    totalProducts: number;
    averagePrice: number;
    averageDeliveryFee: number;
    freeDeliveryCount: number;
    paidDeliveryCount: number;
    priceRange: { min: number; max: number };
    deliveryFeeRange: { min: number; max: number };
    totalRealSold: number;
  } {
    if (products.length === 0) {
      return {
        totalProducts: 0,
        averagePrice: 0,
        averageDeliveryFee: 0,
        freeDeliveryCount: 0,
        paidDeliveryCount: 0,
        priceRange: { min: 0, max: 0 },
        deliveryFeeRange: { min: 0, max: 0 },
        totalRealSold: 0
      };
    }

    const prices = products.map(p => p.price);
    const deliveryFees = products.map(p => p.delivery_fee || 0);
    const realSold = products.map(p => this.getRealSoldQuantity(p));
    
    return {
      totalProducts: products.length,
      averagePrice: prices.reduce((a, b) => a + b, 0) / prices.length,
      averageDeliveryFee: deliveryFees.reduce((a, b) => a + b, 0) / deliveryFees.length,
      freeDeliveryCount: deliveryFees.filter(fee => fee === 0).length,
      paidDeliveryCount: deliveryFees.filter(fee => fee > 0).length,
      priceRange: { min: Math.min(...prices), max: Math.max(...prices) },
      deliveryFeeRange: { min: Math.min(...deliveryFees), max: Math.max(...deliveryFees) },
      totalRealSold: realSold.reduce((a, b) => a + b, 0)
    };
  }

  // ===== UTILITAIRES ADMIN =====
  
  // ✅ NOUVEAU - Formater les informations owner
  formatOwnerInfo(product: Product): string {
    const parts = [];
    if (product.owner_name) parts.push(product.owner_name);
    if (product.owner_email) parts.push(product.owner_email);
    if (product.owner_phone) parts.push(product.owner_phone);
    return parts.join(' • ') || `Farmer #${product.owner_id}`;
  }

  // ✅ NOUVEAU - Déterminer si un produit nécessite attention admin
  needsAdminAttention(product: Product): {
    needsAttention: boolean;
    reasons: string[];
  } {
    const reasons: string[] = [];
    
    // Prix suspect (trop élevé ou trop bas)
    if (product.price > 500000) reasons.push('Prix très élevé');
    if (product.price < 100) reasons.push('Prix très bas');
    
    // Stock problématique
    if (product.stock === 0) reasons.push('Rupture de stock');
    if (product.stock > 10000) reasons.push('Stock très élevé');
    
    // Description manquante ou trop courte
    if (!product.description || product.description.length < 20) {
      reasons.push('Description insuffisante');
    }
    
    // Nom suspect
    if (product.name.length < 3) reasons.push('Nom trop court');
    if (/[0-9]{6,}/.test(product.name)) reasons.push('Nom suspect (beaucoup de chiffres)');
    
    return {
      needsAttention: reasons.length > 0,
      reasons
    };
  }

  // ✅ NOUVEAU - Catégoriser les produits par problème
  categorizeProductIssues(products: Product[]): {
    noIssues: Product[];
    priceIssues: Product[];
    stockIssues: Product[];
    contentIssues: Product[];
    multipleIssues: Product[];
  } {
    const noIssues: Product[] = [];
    const priceIssues: Product[] = [];
    const stockIssues: Product[] = [];
    const contentIssues: Product[] = [];
    const multipleIssues: Product[] = [];
    
    products.forEach(product => {
      const { needsAttention, reasons } = this.needsAdminAttention(product);
      
      if (!needsAttention) {
        noIssues.push(product);
        return;
      }
      
      if (reasons.length > 1) {
        multipleIssues.push(product);
        return;
      }
      
      const reason = reasons[0];
      if (reason.includes('Prix')) {
        priceIssues.push(product);
      } else if (reason.includes('stock') || reason.includes('Stock')) {
        stockIssues.push(product);
      } else {
        contentIssues.push(product);
      }
    });
    
    return { noIssues, priceIssues, stockIssues, contentIssues, multipleIssues };
  }
}

export default new ProductService();